export const iconFontAwesomeEnergyTowerBroadcast = (
	<i className="fa-solid fa-tower-broadcast"></i>
);
